import { Nullable } from '~types/common';
import { isClient } from '~utils/lodash/isServer';

type TrackingEvent = string;
export type EventProperties = Record<string, any>;

/**
 * GTM 데이터를 추가하는 함수
 *
 * https://developers.google.com/tag-platform/tag-manager/web/datalayer#use_a_data_layer_with_event_handlers
 *
 * @param event
 * @param eventProperties
 */
export function setGtmDataLayer(event: TrackingEvent, eventProperties?: EventProperties) {
  const dataLayer = {
    event,
  };

  if (isClient) {
    const windowDataLayer = window.dataLayer || [];
    windowDataLayer.push(Object.assign(dataLayer, eventProperties));
  }
}

/**
 * 앰플리튜드 user id 설정하는 함수
 * @param properties
 */
export function setAmplitudeUserId(userId: Nullable<string | number>) {
  if (isClient && window.amplitude) {
    window.amplitude.getInstance().setUserId(userId);
  }
}

/**
 * 앰플리튜드 user property 추가하는 함수
 * @param properties
 */

export function setAmplitudeUserProperties(properties: EventProperties) {
  if (isClient && window.amplitude) {
    window.amplitude.getInstance().setUserProperties(properties);
  }
}
